import { AxiosResponse } from 'axios';

export const executeDownload = (response: AxiosResponse<Blob, unknown>): boolean => {
  const disposition = response.headers['content-disposition'];
  const type = response.headers['content-type'];
  if (disposition != null && type != null) {
    let filename: string | undefined;
    const filenameRegex1 = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches1 = filenameRegex1.exec(disposition);
    if (matches1 != null && matches1[1] != null) {
      filename = decodeURIComponent(matches1[1].replace(/['"]/g, ''));
    }
    const filenameRegex2 = /filename\*=utf-8''((['"]).*?\2|[^;\n]*)/;
    const matches2 = filenameRegex2.exec(disposition);
    if (matches2 != null && matches2[1] != null) {
      filename = decodeURIComponent(matches2[1].replace(/['"]/g, ''));
    }
    if (filename != null) {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(response.data);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
      return true;
    }
  }
  return false;
};
